export default __webpack_public_path__ + "static/media/DensoWaveScannerRed.70242615.svg";